/**
 * Client-side change-detection for Cost Structure History (audit) records.
 * Kept free of provider/network/react-admin imports so it can be unit-tested
 * under jest without dragging in the data provider stack.
 */

/**
 * Keeps only records where one of the given fields changed vs the previous
 * record. Records must be pre-sorted by createdAt DESC (newest first); the
 * oldest record is always kept so users see the initial snapshot.
 */
export const filterByFieldChanges = <T>(records: T[], fields: string[]): T[] => {
  if (records.length === 0) return [];

  return records.filter((record, index) => {
    if (index === records.length - 1) return true;

    const current = record as Record<string, unknown>;
    const previous = records[index + 1] as Record<string, unknown>;

    return fields.some(field => current[field] !== previous[field]);
  });
};
